<form [formGroup]="baseFormGroup" #f="ngForm" class="mt-4 pl-2">
  <div class="form-horizontal">
    <div class="row">
      <div class="col-md-12">
        <div class="form-group row">
          <!-- <label class="col-form-label col-2"><span translate="BANKA.SIFRA.SINGULAR"></span></label> -->
          <div class="col-md-12">
            <yt-input
              [Type]="'text'"
              name="txtSifra"
              formControlName="Sifra"
              #focusElement
              [MaxLength]="4"
              [ngClass]="{ 'is-invalid': submitted && fc.Sifra.invalid }"
              [Label]="'BANKA.SIFRA.SINGULAR'"
            >
            </yt-input>
            <div class="form-error" *ngIf="submitted && fc.Sifra.invalid">
              <span *ngFor="let validation of errorMessages.Sifra">
                <span
                  class="error-message"
                  *ngIf="fc.Sifra.hasError(validation.type)"
                  ><span translate="{{ validation.message }}"></span
                ></span>
              </span>
              <!-- <span *ngIf="fc.Sifra.errors.required">Šifra je obavezan podatak</span> -->
            </div>
          </div>
        </div>
        <div class="form-group row">
          <!-- <label class="col-form-label col-2"><span translate="BANKA.NAZIV.SINGULAR"></span></label> -->
          <div class="col-md-12">
            <yt-input
              [Type]="'text'"
              name="txtNaziv"
              formControlName="Naziv"
              [MaxLength]="100"
              [ngClass]="{ 'is-invalid': submitted && fc.Naziv.invalid }"
              [Label]="'BANKA.NAZIV.SINGULAR'"
            >
            </yt-input>
            <div class="form-error" *ngIf="submitted && fc.Naziv.invalid">
              <span *ngFor="let validation of errorMessages.Naziv">
                <span
                  class="error-message"
                  *ngIf="fc.Naziv.hasError(validation.type)"
                  ><span translate="{{ validation.message }}"></span
                ></span>
              </span>
              <!-- <span *ngIf="fc.Naziv.errors.required">Naziv je obavezan podatak</span> -->
            </div>
          </div>
        </div>
        <div class="form-group row">
          <!-- <label class="col-form-label col-2"><span translate="BANKA.SWIFT.SINGULAR"></span></label> -->
          <div class="col-md-12">
            <yt-input
              [Type]="'text'"
              name="txtSwift"
              formControlName="Swift"
              [MaxLength]="11"
              [Label]="'BANKA.SWIFT.SINGULAR'"
            >
            </yt-input>
          </div>
        </div>
        <div class="form-group row">
          <!-- <label class="col-form-label col-2"><span translate="BANKA.ABA.SINGULAR"></span></label> -->
          <div class="col-md-12">
            <yt-input
              [Type]="'text'"
              name="txtAba"
              formControlName="Aba"
              [MaxLength]="10"
              [Label]="'BANKA.ABA.SINGULAR'"
            >
            </yt-input>
          </div>
        </div>
        <div class="form-group row">
          <!-- <label class="col-form-label col-2"><span translate="BANKA.ADRESA.SINGULAR"></span></label> -->
          <div class="col-md-12">
            <yt-input
              [Type]="'text'"
              name="txtBroj"
              formControlName="Adresa"
              [MaxLength]="100"
              [ngClass]="{ 'is-invalid': submitted && fc.Adresa.invalid }"
              [Label]="'BANKA.ADRESA.SINGULAR'"
            >
            </yt-input>
            <div class="form-error" *ngIf="submitted && fc.Adresa.invalid">
              <span *ngFor="let validation of errorMessages.Adresa">
                <span
                  class="error-message"
                  *ngIf="fc.Adresa.hasError(validation.type)"
                  ><span translate="{{ validation.message }}"></span
                ></span>
              </span>
              <!-- <span *ngIf="fc.Adresa.errors.required">Adresa je obavezan podatak</span> -->
            </div>
          </div>
        </div>
        <div class="form-group row">
          <!-- <label class="col-form-label col-2"><span translate="BANKA.MESTO.SINGULAR"></span></label> -->
          <div class="col-md-12">
            <!-- <yt-dropdown-picklist
                    [ModelName]="'mesto'"
                    [GetName]="'get'"
                    [ModelProperty]="'Naziv'"
                    [OrderBy]="'Naziv'"
                    [AllowAddNew]="true"
                    formControlName="MestoID"
                    [Label]="'BANKA.MESTO.SINGULAR'"
                    >
              </yt-dropdown-picklist> -->

            <yt-autocomplete
              [ModelName]="'mesto'"
              [GetName]="'getByNaziv'"
              [ModelProperty]="'Naziv'"
              [OrderBy]="'Naziv'"
              [Label]="'BANKA.MESTO.SINGULAR'"
              formControlName="MestoID"
            >
            </yt-autocomplete>

            <!-- <yt-fw-dropdown
              [ModelName]="'mesto'"
              [GetName]="'get'"
              [ModelProperty]="'Naziv'"
              [OrderBy]="'Naziv'"
              [AllowAddNew]='true'
              [Required]='true'
              [Disabled]='false'
              formControlName="MestoID"
              name="cmbMesto"
              [Type]="ID"
              [ngClass]="{'is-invalid': submitted && fc.MestoID.invalid}"
              [Label]="'BANKA.MESTO.SINGULAR'">              
            </yt-fw-dropdown> -->
            <div class="form-error" *ngIf="submitted && fc.MestoID.invalid">
              <span *ngFor="let validation of errorMessages.MestoID">
                <span
                  class="error-message"
                  *ngIf="fc.MestoID.hasError(validation.type)"
                  ><span translate="{{ validation.message }}"></span
                ></span>
              </span>
            </div>
          </div>
        </div>
        <div class="form-group row">
          <!-- <label class="col-form-label col-2"><span translate="BANKA.CANADATRANSITCODE.SINGULAR"></span></label> -->
          <div class="col-md-12">
            <yt-input
              [Type]="'text'"
              name="txtCanadaTransitCode"
              formControlName="CanadaTransitCode"
              [MaxLength]="5"
              [Label]="'BANKA.CANADATRANSITCODE.SINGULAR'"
            >
            </yt-input>
          </div>
        </div>
      </div>
    </div>
  </div>
</form>
